import { HOTSPOT_GAP, HotspotPosition } from './interactive3Placement';

/** Enlarge the image, not the controls. This is offered, never applied on load. */
export function zoomForHotspots(
  points: HotspotPosition[],
  width: number,
  height: number
) {
  let zoom = 1;
  for (let i = 0; i < points.length; i++) {
    for (let j = i + 1; j < points.length; j++) {
      const a = points[i];
      const b = points[j];
      const distance = Math.hypot(
        ((a.left - b.left) * width) / 100,
        ((a.top - b.top) * height) / 100
      );
      // Identical anchors cannot be separated by zoom. New coincident drops
      // are rejected by the current-canvas placement check.
      if (distance > 0) {
        zoom = Math.max(zoom, ((a.size + b.size) / 2 + HOTSPOT_GAP) / distance);
      }
    }
  }
  // Leave rounding clearance when source/image pixels map to CSS pixels.
  return zoom > 1 ? Math.ceil(zoom * 100 + 1) / 100 : 1;
}
